import { Perfil } from './perfil.interface';
import { PerfilDto } from './perfil.dto';

export class PerfilMapper {
  static fromDto(dto: PerfilDto): Perfil {
    return {
      perfilId: dto.perfil_ID,
      nombrePerfil: dto.nombre_Perfil
    };
  }

  static fromDtoList(dtoList: PerfilDto[]): Perfil[] {
    return dtoList.map(dto => this.fromDto(dto));
  }

  static toDto(model: Perfil): PerfilDto {
    return {
      perfil_ID: model.perfilId,
      nombre_Perfil: model.nombrePerfil
    };
  }
}
